import type { AppConfig } from '@/features/controller/configuration/models/appConfigSchema'

export function readAppJsonToModel(value: string) {
  return JSON.parse(value) as AppConfig
}

export function writeModelToAppJson(appConfig: AppConfig) {
  return JSON.stringify(appConfig, null, 2)
}
